import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { DialogComponent } from '../../../common/dialog/dialog.component';
import { AppConfig } from '../../../shared/class/appconfig.class';
import { HeaderTitleService } from '../../../shared/service/headerTitle.service';
import { NavigationService } from '../../../shared/service/navigation.service';
import { MaintenanceEmployeeService } from '../maintenance-employee.service';

/**
 * 社員マスタリストコンポーネント
 */
@Component({
  selector: 'app-maintenance-employee',
  templateUrl: './employee-list.component.html',
  styleUrls: ['./employee-list.component.css']
})
export class EmployeeListComponent implements OnInit {
  /**
   * 社員マスタリストコンポーネントのコンストラクター
   * @constructor
   */
  constructor(private title: Title,
              private headerTitle: HeaderTitleService,
              private transitionService: NavigationService,
              private router: Router,
              private matDialog: MatDialog,
              private matSnackBar: MatSnackBar,
              private empService: MaintenanceEmployeeService) {
    // ページタイトルの設定
    this.title.setTitle('社員マスタリスト | ' + AppConfig.SYSTEM_NANE);
    // ヘッダータイトルの設定
    this.headerTitle.setTitle('社員マスタリスト');
  }

  /** 取得した社員一覧を格納 */
  public dataSource = new MatTableDataSource();
  /** 選択した社員情報 */
  public selected: any;
  /** チェックボックスの状態 */
  public deleteCheckStatus = false;
  /** サービスに渡す引数 */
  public deleteCheck = 0;
  /** 修正ボタンの状態 */
  public isDisabledModify = true;
  /** 削除ボタンの状態 */
  public isDisabledDelete = true;
  /** 復元ボタンの状態 */
  public isDisabledRestore = true;

  /** 画面表示項目 */
  public displayedColumns: string[] = [
    'employee_no',        // 社員番号
    'employee_name',      // 社員名
    'department_name',    // 所属部署
    'mail_address',       // メールアドレス
    'mobile_number',      // 携帯電話番号
    'join_company_date',  // 入社日
    'leave_company_date', // 退社日
    'delete_flag',        // 削除フラグ
    'created_by',         // 作成者
    'create_datetime',    // 作成日時
    'updated_by',         // 更新者
    'update_datetime',    // 更新日時
  ];
  /** 削除フラグの画面表示(falseの場合は空白、trueの場合は○を表示) */
  public isDeleted = { '=false': '', '=true': '○' };

  /**
   * 初期表示時の処理
   */
  async ngOnInit(): Promise<void> {
    // 修正ボタン、削除ボタン、復元ボタンを非活性
    this.isDisabledModify = true;
    this.isDisabledDelete = true;
    this.isDisabledRestore = true;

    // 選択した社員情報をクリア
    this.selected = null;

    // 社員一覧を取得
    await this.getEmployeeList();
  }

  /**
   * 行選択時の処理
   * @param employee 行選択した社員情報
   */
  public selectedRow(employee) {
    // 選択した社員情報をセットする
    this.selected = employee;

    if (employee.delete_flag) {
      // 修正ボタン、削除ボタンを活性、復元ボタンを非活性
      this.isDisabledModify = true;
      this.isDisabledDelete = true;
      this.isDisabledRestore = false;
    } else {
      // 修正ボタン、削除ボタンを非活性、復元ボタンを活性
      this.isDisabledModify = false;
      this.isDisabledDelete = false;
      this.isDisabledRestore = true;
    }
  }

  /**
   * 新規登録ボタン押下時の処理
   */
  public onEntry() {
    // 画面遷移の許可
    this.transitionService.canTransition = true;
    // 社員マスタ登録画面に遷移
    this.router.navigate(['/maintenance/employee/entry']);
  }

  /**
   * 修正ボタン押下時の処理
   */
  public onModify() {
    // 社員番号をサービスに保存
    this.empService.sendDetailInfomation(this.selected.employee_no);
    // 画面遷移の許可
    this.transitionService.canTransition = true;
    // 社員マスタ修正画面に遷移
    this.router.navigate(['/maintenance/employee/modify']);
  }

  /**
   * 削除ボタン押下時の処理
   *
   * 選択された社員情報を論理削除する。
   */
  public onDelete() {
    // 処理開始前に確認ダイアログを表示
    const dialogRef =  this.matDialog.open(DialogComponent, {
      width: '300px',
      height: '300px',
      data: {
        title: '削除確認',
        message: '現在選択されている社員を削除してよろしいですか？',
      },
      // 画面外のクリックを禁止する設定を追加
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(async(result) => {
      if (!result) {
        // 社員を削除する
        const rec: any = await this.empService.deleteEmployeeDetail(this.selected.employee_no);

        // 削除に失敗した場合、サーバから返ってきたメッセージを表示する
        if (!rec.success) {
          alert(rec.message);
          return;
        }
        // 削除後処理
        this.matSnackBar.open('削除しました。', '', {
          duration: 1000
        });
        console.log('@@@@ 削除処理が完了しました。');

        // 社員一覧を再取得する
        this.ngOnInit();
      } else {
        // キャンセル押下時は何もしない
        return;
      }
    });
  }

  /**
   * 復元ボタン押下時の処理
   *
   * 削除された社員の削除済みフラグをtrueに更新する。
   */
  public onRestore() {
    // 処理開始前に確認ダイアログを表示
    const dialogRef =  this.matDialog.open(DialogComponent, {
      width: '300px',
      height: '300px',
      data: {
        title: '復元確認',
        message: '現在選択されている社員を復元してよろしいですか？',
      },
      // 画面外のクリックを禁止する設定を追加
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(async(result) => {
      if (!result) {
        // 社員を復元する
        const rec: any = await this.empService.restoreEmployeeDetail(this.selected.employee_no);

        // 復元に失敗した場合、サーバから返ってきたメッセージを表示する
        if (!rec.success) {
          alert(rec.message);
          return;
        }
        // 復元後処理
        this.matSnackBar.open('復元しました。', '', {
          duration: 1000
        });
        console.log('@@@@ 復元処理が完了しました。');

        // 社員一覧を再取得する
        this.ngOnInit();
      } else {
        // キャンセル押下時は何もしない
        return;
      }
    });
  }

  /**
   * チェックボックスの値変更時の処理
   *
   * チェックの有無で値を更新する。
   * チェック状態を変更後に再検索を行い、社員一覧を再取得する。
   * @param event チェックボックス
   */
  setDeleteCheck(event) {
    if (event.checked) {
      this.deleteCheck = 1;
    } else {
      this.deleteCheck = 0;
    }

    // 社員一覧を再取得する
    this.ngOnInit();
  }

  /**
   * 社員一覧を取得する。
   */
  private async getEmployeeList() {
    // 社員一覧を取得する
    const rec: any = await this.empService.getEmployeeList(this.deleteCheck);
    // 取得した結果をテーブルにセットする
    this.dataSource = rec;
  }
}
